<script>
import BaseInput from "../Base/BaseInput.vue";
import BaseInput2 from "../Base/BaseInput2.vue";
import BaseInput3 from "../Base/BaseInput3.vue";
import TinymceEditor from "../Base/TinymceEditor3.vue";
import BaseLocation from "../Base/BaseLocationCountryRegionCity.vue";
import BaseMonthPicker from "../Base/BaseMonthPicker.vue";
import BaseYearPicker from "../Base/BaseYearPicker.vue";
import AgeField from "./components/AgeField.vue";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faQuestion} from '@fortawesome/free-solid-svg-icons';
import {library} from '@fortawesome/fontawesome-svg-core';
import {Field, Form} from 'vee-validate';
import ValidationService from "@/services/ValidationService"


library.add(faQuestion);
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import axios from "axios";
import {mapState, mapStores} from 'pinia'
import {useCompetitionToProjectInfo} from "@/stores/competitionToProjectInfo";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";
import BaseLocationCountryRegionCity from "@/components/Base/BaseLocationCountryRegionCity.vue";

export default {
  name: 'CompleteProjectForm128',
  props: {
    isDataUpdating: {},
    isSubmitted: {}
  },
  created() {
    this.isLoading = true;
    this.checkIsUserFillProfile().then(() => {
      //Если выбран активный конкурс, куда подается заявка.
      if (window.competitionId?.length > 0) {
        this.selectedCompetitionId = window.competitionId;
        //this.loadCompetition(this.selectedCompetitionId);
        this.$emit('loadCompetition', this.selectedCompetitionId)

        if (window.new.length > 0) {
          this.getData(false, false);
        } else {
          this.getData(true, true);
        }
      } else {
        //this.loadCompetitions(1);
        this.$emit('loadCompetitions', 1)

        //Если после добавления нового проекта.
        if (window.new.length > 0) {
          this.getData(false, false);
        } else {
          this.getData(true, true)
        }
      }
    });
    this.isLoading = false;
  },
  data() {
    return {
      imgSrc: '',
      //locale: locale,
      project: null,
      isLoading: false,
      validationRules: [],
      countriesinput: [],
      tabNum: 1,
      errors: [],
      commandphoto: '',
      inroles: '',
      scenarist_text: '',
      scenarist_phone: '',
      scenarist_email: '',
      scenarist_bio: '',
      regiser_text: '',
      regiser_phone: '',
      regiser_email: '',
      regiser_bio: '',
      producer_text: '',
      producer_phone: '',
      producer_email: '',
      producer_bio: '',
      operator_text: '',
      compositor_text: '',
      chudoznik_text: '',
      isUserFillProfile: false,
	    selectedCompetitionCategory: '',
      store: useCompetitionToProjectInfo()
    }
  },
  components: {
    BaseLocationCountryRegionCity,
    BaseMonthPicker,
    BaseYearPicker,
    BaseInput,
    BaseInput2,
    BaseInput3,
    TinymceEditor,
    BaseLocation,
    VueCropper,
    FontAwesomeIcon,
    ImageRender,
    Field,
    Form,
    AgeField
  },
  methods: {
    async getData(checkErrors = false, showModal = false) {

      let project_data = {
        age_limit: '',
        treiler: '',
        premiera: '',
        zhanr: [],
        mounth_relise: '',
        authorScenarios: [
          {
            fio: '',
            phone: '',
            email: '',
            bio: '',
            birthday: ''
          }
        ],
        regisers: [
          {
            fio: '',
            phone: '',
            email: '',
            bio: '',
            birthday: ''
          }
        ],
        producers: [
          {
            fio: '',
            phone: '',
            email: '',
            bio: '',
            birthday: ''
          }
        ],
        operators: [
          {
            fio: '',
            birthday: ''
          }
        ],
        compositors: [
          {
            fio: '',
            birthday: ''
          }
        ],
        hydozniks: [
          {
            fio: '',
            birthday: ''
          }
        ]
      };
      const response = await axios.get('/api/projects/' + window.projectId, {
        headers: {
          'Accept': 'application/json',
        }
      }).catch(error => {
        console.log(error);
      });

      this.commandphoto = response.data?.project_command?.command_photo;
      this.inroles = response.data?.project_command?.inroles;
      this.scenarist_text = response.data?.project_command?.scenarist_text;
      this.scenarist_phone = response.data?.project_command?.scenarist_phone;
      this.scenarist_email = response.data?.project_command?.scenarist_email;
      this.scenarist_bio = response.data?.project_command?.scenarist_bio;
      this.regiser_text = response.data?.project_command?.regiser_text;
      this.regiser_phone = response.data?.project_command?.regiser_phone;
      this.regiser_email = response.data?.project_command?.regiser_email;
      this.regiser_bio = response.data?.project_command?.regiser_bio;
      this.producer_text = response.data?.project_command?.producer_text;
      this.producer_phone = response.data?.project_command?.producer_phone;
      this.producer_bio = response.data?.project_command?.producer_bio;
      this.producer_email = response.data?.project_command?.producer_email;
      this.operator_text = response.data?.project_command?.operator_text;
      this.compositor_text = response.data?.project_command?.compositor_text;
      this.chudoznik_text = response.data?.project_command?.chudoznik_text;

      this.project = response.data;

      if (this.project.project_data === null || Array.isArray(this.project.project_data)) {
        this.project.project_data = {};
      }

      for (var key in project_data) {
        if (key === 'zhanr') {
          this.project.project_data[key] = response.data.project_data[key] ?? [];
        } else if (key === 'authorScenarios') {
          this.project.project_data[key] = response.data.project_data[key] ?? [
            {
              fio: '',
              phone: '',
              email: '',
              bio: '',
              birthday: ''
            }
          ];
        } else if (key === 'regisers') {
          this.project.project_data[key] = response.data.project_data[key] ?? [
            {
              fio: '',
              phone: '',
              email: '',
              bio: '',
              birthday: ''
            }
          ];
        } else if (key === 'producers') {
          this.project.project_data[key] = response.data.project_data[key] ?? [
            {
              fio: '',
              phone: '',
              email: '',
              bio: '',
              birthday: ''
            }
          ];
        } else if (key === 'operators') {
          this.project.project_data[key] = response.data.project_data[key] ?? [
            {
              fio: '',
              birthday: ''
            }
          ];
        } else if (key === 'compositors') {
          this.project.project_data[key] = response.data.project_data[key] ?? [
            {
              fio: '',
              birthday: ''
            }
          ];
        } else if (key === 'hydozniks') {
          this.project.project_data[key] = response.data.project_data[key] ?? [
            {
              fio: '',
              birthday: ''
            }
          ];
        } else {
          this.project.project_data[key] = response.data.project_data[key] ?? '';
        }
      }

      if (checkErrors) {
        if (showModal) {
          this.checkErrors(false, true);
        } else {
          this.checkErrors(false);
        }
      }

      //this.$parent.isLoading = false;
      this.$emit('onDataUpdating', false);

      if (this.countriesinput.length === 0) {
        await this.loadCountries();
      }
    },
    saveData: function () {
      let self = this;
      if (!this.isDataUpdating) {
        this.$emit('onDataUpdating', true);

        axios.patch('/api/projects/' + window.projectId,
          {
            'name': this.project.name,
            'publishYear': parseInt(this.project.publish_year),
            'chronometr': this.project.chronometr,
            'zhanr': this.project.zhanr,
            'category': this.project.category,
            'production': this.project.production,
            'annotation': this.project.annotation,
            'filmRights': this.project.film_rights,
            'filmRightsPhone': this.project.film_rights_phone,
            'filmRightsEmail': this.project.film_rights_email,
            'videoLink': this.project.video_link,
            'tagline': this.project.tagline,
            'socialVideolink': this.project.social_videolink,
            'videoSource': this.project.video_source,
            'prioritySocial': this.project.priority_social,
            'musicRights': this.project.music_rights,
            'filmLanguage': this.project.film_language,
            'motivation': this.project.motivation,
            'country': this.project.country,
            'city': this.project.city,
            'region': this.project.region,
            'projectCommand': {
              'commandPhoto': this.commandphoto,
              'inroles': this.inroles,
              'scenaristText': this.scenarist_text,
              'scenaristPhone': this.scenarist_phone,
              'scenaristEmail': this.scenarist_email,
              'scenaristBio': this.scenarist_bio,
              'regiserText': this.regiser_text,
              'regiserPhone': this.regiser_phone,
              'regiserEmail': this.regiser_email,
              'regiserBio': this.regiser_bio,
              'producerText': this.producer_text,
              'producerPhone': this.producer_phone,
              'producerEmail': this.producer_email,
              'producerBio': this.producer_bio,
              'operatorText': this.operator_text,
              'compositorText': this.compositor_text,
              'chudoznikText': this.chudoznik_text
            },
            'projectData': this.project.project_data
          },
          {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/merge-patch+json',
            }
          }
        ).then((response) => {
          if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
            alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
            window.location.reload();
          }

          self.getData()
        }).catch(error => {
          console.log(error);
          alert('Ошибка получения данных')
        });
      }
    },
    changeCurrentTab(num) {
      this.tabNum = num;
      document.getElementById('tabContent').scrollIntoView({behavior: 'smooth'});
    },
    isRequired(val) {
      return ValidationService.isRequired(val);
    },
    validateField(field) {
      const self = this;
      if (field.parentEntity !== undefined) {
        if (self.project) {
          if (field.isRequired && (self.project[field.parentEntity] === null || self.project[field.parentEntity][field.fieldName] === undefined || (self.project[field.parentEntity][field.fieldName] === null || self.project[field.parentEntity][field.fieldName].length === 0 || self.project[field.parentEntity][field.fieldName] === 0 || self.project[field.parentEntity][field.fieldName] === false))) {
            if (!self.errors.find(x => x.text === field.errorText)) {
              self.errors.push({
                text: field.errorText,
                order: field.order ? field.order : '1'
              });
            }
          }
        }
      } else {
        if (self.project) {
          if (field.isRequired && (self.project[field.fieldName] === null || self.project[field.fieldName]?.length === 0 || self.project[field.fieldName] === 0)) {
            if (!self.errors.find(x => x.text === field.errorText)) {
              self.errors.push({
                text: field.errorText,
                order: field.order ? field.order : '1'
              });
            }
          }
        }
      }
    },
    isFieldVisible(fieldName) {
      let res = true;
      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if ((field.fieldName === fieldName || field?.altFieldName === fieldName) && !field.isRequired && !field.isNeeded) {
            res = false;
          }
        });
      }
      return res;
    },
    isFieldRequired(fieldName) {
      let res = false;
      this.validationRules.forEach(function (field) {
        if (
          (field.fieldName === fieldName || field?.altFieldName === fieldName)
          && field.isRequired) {
          res = true;
        }
      });

      if (this.selectedCompetition?.projectRules) {
        this.selectedCompetition?.projectRules.forEach(function (field) {
          if (
            (field.fieldName === fieldName || field?.altFieldName === fieldName)
            && field.isRequired) {
            res = true;
          }
        });
      }
      return res;
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Загрузить можно только изображение");
        return;
      }
      if (file.size > 1572864) {
        alert("Максимальный размер изображения 1,5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
        return;
      }
      this.origfilename = file.name;
      const self = this;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          self.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          if (self.$refs.cropper) {
            self.$refs.cropper.replace(event.target.result);
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      const self = this;
      this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
        let formData = new FormData();
        formData.append('file', blob);
        formData.append('original-name', self.origfilename);
        formData.append('current-name', self.project.afisha);
        formData.append('entity-id', self.project.id);

        axios(
          {
            method: 'post',
            url: '/project/getProjectAvatar',
            data: formData
          }
        )
          .then(() => {
            self.imgSrc = '';
            self.getData();

          });
      })
    },
    checkErrors(withScroll = true, showModal = false) {
      const self = this;

      this.$nextTick(() => {
        this.isLoading = true;
        this.$parent.isLoading = true;
        this.errors = [];

        if (this.$refs.clientForm) {
          this.$refs.clientForm.validate().then((valid) => {
            
            if (!valid.valid) {
              if (showModal) {
                self.$parent.showModal();
              }
              for (const key in valid.errors) {
                self.errors.push({
                  text: `Поле "${this.getFieldNameByIndex(key)}" обязательно для заполнения`,
                  order: '1'
                });
              }

              if (!self.isUserFillProfile) {
                self.errors.push({
                  text: 'Заполните информацию в своем Профиле <a href="https://script.moviestart.ru/myprofile?check=true">https://script.moviestart.ru/myprofile</a>',
                  order: '1'
                });
              }

              if (withScroll && Object.keys(valid.errors).length > 0) {
                if (document.getElementById("clientForm")) {
                  document.getElementById("clientForm").scrollIntoView();
                }
              }
            }
            else {
              this.makeProjectInfo()
            }
            
          });
        }

        this.isLoading = false;
        this.$parent.isLoading = false;
      });
    },
    async makeProjectInfo() {
      if (!this.isProjectInfoSubmitted) {
        this.isLoading = true;

        let url = '/competition/apiAddProject/' + this.selectedCompetition.id + '/' + window.projectId + '/' + this.categoryId;

        const response = await axios.get(url, {
          headers: {
            'Accept': 'application/ld+json',
          }
        })
        if (response.data['error']) {
          alert(response.data['error'])
        }
        
	      await this.setSelectedCompetition(this.selectedCompetitionId)
				this.isLoading = false;
      }
    },
    async setSelectedCompetition(id) {
      let response;
      response = await axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId);
      this.store.selectedCompetition  = response?.data;
    },
    checkIsUserFillProfile() {
      return new Promise((resolve, reject) => {
        const self = this;
        axios.get('/isUserFillProfile', {
          headers: {
            'Accept': 'application/json',
          }
        })
          .then(response => {
            self.isUserFillProfile = response.data;
            resolve(response.data)
          })
          .catch(error => {
            console.log(error);
            reject(error)
          });
      });
    },
    async loadCountries() {
      const response = await axios.get('/get_all_countries', {
        headers: {
          'Accept': 'application/json',
        }
      })
      this.countriesinput = response.data;
    },
    loadCities() {
      const self = this;
      const current_country = self.countriesinput.filter(function (el) {
        return el["ru_name"] === self.project.country;
      })
      if (current_country[0] && current_country[0].number) {
        axios.get('/get_world_cities/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {
          self.citiestoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    getProjectAvatar(avatar) {
      return ImageService.getProjectImagePath(avatar);
    },
    addAuthorScenario() {
      this.project.project_data.authorScenarios.push({
        fio: '',
        phone: '',
        email: '',
        bio: '',
        birthday: ''
      });
      this.saveData();
    },
    removeAuthorScenario(index) {
      this.project.project_data.authorScenarios.splice(index, 1);
      this.saveData();
    },
    addRegiser() {
      this.project.project_data.regisers.push({
        fio: '',
        phone: '',
        email: '',
        bio: '',
        birthday: ''
      });
      this.saveData();
    },
    removeRegiser(index) {
      this.project.project_data.regisers.splice(index, 1);
      this.saveData();
    },
    addProducer() {
      this.project.project_data.producers.push({
        fio: '',
        phone: '',
        email: '',
        bio: '',
        birthday: ''
      });
      this.saveData();
    },
    removeProducer(index) {
      this.project.project_data.producers.splice(index, 1);
      this.saveData();
    },
    addOperator() {
      this.project.project_data.operators.push({
        fio: '',
        birthday: ''
      });
      this.saveData();
    },
    removeOperator(index) {
      this.project.project_data.operators.splice(index, 1);
      this.saveData();
    },
    addCompositor() {
      this.project.project_data.compositors.push({
        fio: '',
        birthday: ''
      });
      this.saveData();
    },
    removeCompositor(index) {
      this.project.project_data.compositors.splice(index, 1);
      this.saveData();
    },
    addHydoznik() {
      this.project.project_data.hydozniks.push({
        fio: '',
        birthday: ''
      });
      this.saveData();
    },
    removeHydoznik(index) {
      this.project.project_data.hydozniks.splice(index, 1);
      this.saveData();
    },
    getFieldNameByIndex(index) {
      let res = '';

      if (index === 'name') {
        res = 'Название фильма';
      } else if (index === 'publish_year') {
        res = 'Год выпуска';
      } else if (index === 'chronometr') {
        res = 'Продолжительность фильма (мин.)';
      } else if (index === 'zhanr') {
        res = 'Формат';
      } else if (index === 'project_data_zhanr') {
        res = 'Жанр';
      } else if (index === 'production') {
        res = 'Производство';
      } else if (index === 'annotation') {
        res = 'Краткая аннотация';
      } else if (index === 'film_rights') {
        res = 'Кому принадлежат права на фильм';
      } else if (index === 'film_rights_phone') {
        res = 'Номер телефона владельца прав на фильм';
      } else if (index === 'film_rights_email') {
        res = 'Email владельца прав на фильм';
      } else if (index === 'video_link') {
        res = 'Закрытая ссылка для просмотра фильма';
      } else if (index === 'tagline') {
        res = 'Закрытая ссылка на скачивание фильма';
      } else if (index === 'social_videolink') {
        res = 'Ссылка на фильм в социальных сетях';
      } else if (index === 'video_source') {
        res = 'Ссылка на исходные материалы для фильма';
      } else if (index === 'priority_social') {
        res = 'Ссылки на социальные сети проекта';
      } else if (index === 'command_photo') {
        res = 'Ссылка на кадры';
      } else if (index === 'music_rights') {
        res = 'Кому принадлежат права на музыку';
      } else if (index === 'country') {
        res = 'Страна';
      } else if (index === 'city') {
        res = 'Город';
      } else if (index === 'region') {
        res = 'Регион';
      } else if (index === 'film_language') {
        res = 'На каком языке снят фильм';
      } else if (index === 'motivation') {
        res = 'Мотивация';
      } else if (index === 'inroles') {
        res = 'В ролях';
      } else if (index === 'age_limit') {
        res = 'Возрастное ограничение';
      } else if (index === 'treiler') {
        res = 'Ссылка на трейлер фильма';
      } else if (index === 'premiera') {
        res = 'Премьерность фильма';
      } else if (index === 'scenarist_text') {
        res = 'Автор сценария';
      } else if (index === 'scenarist_phone') {
        res = 'Телефон автора сценария';
      } else if (index === 'scenarist_email') {
        res = 'Email автора сценария';
      } else if (index === 'scenarist_bio') {
        res = 'Биография автора сценария';
      } else if (index === 'regiser_text') {
        res = 'Режиссер';
      } else if (index === 'regiser_phone') {
        res = 'Телефон режиссера';
      } else if (index === 'regiser_email') {
        res = 'Email режиссера';
      } else if (index === 'regiser_bio') {
        res = 'Биография режиссера';
      } else if (index === 'producer_text') {
        res = 'Продюсер';
      } else if (index === 'producer_phone') {
        res = 'Телефон продюсера';
      } else if (index === 'producer_email') {
        res = 'Email продюсера';
      } else if (index === 'producer_bio') {
        res = 'Биография продюсера';
      } else if (index === 'operator_text') {
        res = 'Оператор';
      } else if (index === 'compositor_text') {
        res = 'Композитор';
      } else if (index === 'chudoznik_text') {
        res = 'Художник-постановщик';
      } else if (index === 'afisha') {
        res = 'Афиша проекта';
      } else if (index.startsWith('authorScenarios')) {
        if (index.endsWith('fio')) {
          res = 'Автор сценария ФИО';
        } else if (index.endsWith('phone')) {
          res = 'Телефон автора сценария';
        } else if (index.endsWith('email')) {
          res = 'Email автора сценария';
        } else if (index.endsWith('bio')) {
          res = 'Биография автора сценария';
        } else if (index.endsWith('birthday')) {
          res = 'Дата рождения автора сценария';
        } else {
          res = 'Автор сценария';
        }
      } else if (index.startsWith('regisers')) {
        if (index.endsWith('fio')) {
          res = 'ФИО режиссера';
        } else if (index.endsWith('phone')) {
          res = 'Телефон режиссера';
        } else if (index.endsWith('email')) {
          res = 'Email режиссера';
        } else if (index.endsWith('bio')) {
          res = 'Биография режиссера';
        } else if (index.endsWith('birthday')) {
          res = 'Дата рождения режиссера';
        } else {
          res = 'Режиссер';
        }
      } else if (index.startsWith('producers')) {
        if (index.endsWith('fio')) {
          res = 'ФИО продюсера';
        } else if (index.endsWith('phone')) {
          res = 'Телефон продюсера';
        } else if (index.endsWith('email')) {
          res = 'Email продюсера';
        } else if (index.endsWith('bio')) {
          res = 'Биография продюсера';
        } else if (index.endsWith('birthday')) {
          res = 'Дата рождения продюсера';
        } else {
          res = 'Продюсер';
        }
      } else if (index.startsWith('operators')) {
        if (index.endsWith('fio')) {
          res = 'ФИО оператора';
        } else if (index.endsWith('birthday')) {
          res = 'Дата рождения оператора';
        }
      } else if (index.startsWith('compositors')) {
        if (index.endsWith('fio')) {
          res = 'ФИО композитора';
        } else if (index.endsWith('birthday')) {
          res = 'Дата рождения композитора';
        }
      } else if (index.startsWith('hydozniks')) {
        if (index.endsWith('fio')) {
          res = 'ФИО художника-постановщика';
        } else if (index.endsWith('birthday')) {
          res = 'Дата рождения художника-постановщика';
        }
      } else {
        res = index;
      }

      return res;
    },
    baseInputChangeData(val, index) {
      this.project[index] = val;
      this.saveData();
    },
    sendRequest() {
      this.checkErrors(true);
    },
  },
  computed: {
    ...mapState(useCompetitionToProjectInfo, ['selectedCompetition']),
    ...mapStores(useCompetitionToProjectInfo),
    ai_techs_lists() {
      const items = [
        'Сценарий с применением GPT',
        'Ai-изображения',
	      'Ai-видео',
	      'Ai-музыка',
	      'Ai-речь',
	      'Ai-липсинк',
	      'Ai-обработка видео'
      ]
      return items.map((val) => {
        return {
          value: val
        }
      })
    },
	  competition_categories() {
      const items = this.selectedCompetition?.categories ?? []
      return items.map((val) => {
        return {
          value: val.name
        }
      })
	  },
    isProjectInfoSubmitted() {
      let res = false;
      
      if (this.selectedCompetition.categories && this.selectedCompetition.categories.length > 0) {
        this.selectedCompetition.categories.forEach((category) => {
          if (this.selectedCompetitionCategory === category.name) {
            if (category.isProjectInfoSubmitted === '1') {
							res = true;
            }
          }
        })
      }
      return res;
    },
    isProjectInfoSubmittedInAnyCategory() {
      let res = false;

      if (this.selectedCompetition.categories && this.selectedCompetition.categories.length > 0) {
        this.selectedCompetition.categories.forEach((category) => {
          if (category.isProjectInfoSubmitted === '1') {
            res = true;
          }
        })
      }
      return res;
	  },
    categoryId() {
      let res = 0;

      if (this.selectedCompetition.categories && this.selectedCompetition.categories.length > 0) {
        this.selectedCompetition.categories.forEach((category) => {
          if (this.selectedCompetitionCategory === category.name) {
            res = category.id;
          }
        })
      }
      return res;
    }
  },
  watch: {
    selectedCompetition() {
      //this.checkErrors();
    },
    errors(val) {
      //this.$emit('onErrorsChange', this.errors)
    }
  }
}
</script>

<template>
  <div v-if="!isLoading && project !== null">
	  
	  <template v-if="selectedCompetition">
      <div class="field" style="margin-top: 50px;">
        <label>Выберите категорию конкурса для подачи заявки</label>
        <a-select
            v-model:value="selectedCompetitionCategory"
            :options="competition_categories"
            :allowClear="true"
            placeholder="Выберите значение"
            size="middle"
            style="width: 300px; max-width: 100%"
        />
      </div>

      <div class="create_request" v-if="selectedCompetitionCategory">
	      <template v-if="isProjectInfoSubmittedInAnyCategory">
		      <template v-if="isProjectInfoSubmitted">
            <p style="margin-bottom: 20px;"><strong>Ваша заявка принята</strong></p>
		      </template>
		      <template v-else>
            <p style="margin-bottom: 20px;"><strong>Вы уже отправили заявку в другую категорию</strong></p>
		      </template>
	      </template>
	      <template v-else>
          <p v-if="selectedCompetition?.name" style="margin: 30px 0;"><a class="button2" style=" border: 2px solid #F69F22;"
                                                                         @click.prevent="sendRequest">Подать заявку на
            конкурс</a></p>
          <p style="margin-bottom: 30px">Чтобы подать проект на конкурс пройдите в раздел нужного вам конкурса и нажмите
            "Подать заявку"</p>
	      </template>
      </div>
		  
	  </template>
	  
	  <template v-if="selectedCompetitionCategory.length > 0">
		  <template v-if="selectedCompetitionCategory === 'Нейросетевое кино'">
        <div class="tabs">
          <ul>
            <li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Общая
              информация</a></li>
            <li @click="changeCurrentTab(2)" class="tab tab2" :class="tabNum === 2 ? 'is-active' : ''"><a>Команда</a></li>
          </ul>
        </div>
        <Form ref="clientForm" id="clientForm" v-slot="{errors}">
          <div class="errors-block"
               v-if="Object.keys(errors).length > 0">
            <b>Пожалуйста, заполните поля:</b>
            <ul>
              <li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
                обязательно для заполнения
              </li>
            </ul>
          </div>

	        <template>
            <Field style="display: none" v-model="project.name" name="name"
                   :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.chronometr" name="chronometr"
                   :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.film_rights"
                   name="film_rights" :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.film_rights_phone"
                   name="film_rights_phone" :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.film_rights_email"
                   name="film_rights_email" :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.video_link" name="video_link" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.tagline" name="tagline"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.music_rights"
                   name="music_rights" :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.country" name="country"
                   :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.city" name="city"
                   :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.region" name="region"
                   :rules="isRequired"></Field>
            <Field style="display: none"  v-model="project.film_language"
                   name="film_language" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.motivation" name="motivation"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.annotation" name="annotation"
                   :rules="isRequired"></Field>

            <Field style="display: none" v-model="project.project_data.premiera"
                   name="premiera" :rules="isRequired"></Field>


            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].fio`"
                   v-model="authorScenario.fio"
                   :rules="isFieldRequired('scenarist_text') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].phone`"
                   v-model="authorScenario.phone"
                   :rules="isFieldRequired('scenarist_phone') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].email`"
                   v-model="authorScenario.email"
                   :rules="isFieldRequired('scenarist_email') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].bio`"
                   v-model="authorScenario.bio"
                   :rules="isFieldRequired('scenarist_bio') ? isRequired : undefined"
                   style="display: none"
            ></Field>
		        
		        
	        </template>
	        
          <div v-if="!selectedCompetition?.name">
            <p class="help_text" @click="$parent.showModalQuestion">
              <FontAwesomeIcon icon="question"></FontAwesomeIcon>
              Почему я не вижу обязательные поля для этого проекта?
            </p>
          </div>
	        
          <div id="tabContent">
            <div v-if="tabNum === 1" class="content-tab">
              <div class="columns">
                <div class="column">
                  <BaseInput
                      label="Название фильма"
                      :value="project.name"
                      v-if="isFieldVisible('name')"
                      objectKey="name"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('name')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <TinymceEditor
                      label="Описание фильма/работы"
                      v-model="project.annotation"
                      v-if="isFieldVisible('annotation')"
                      objectKey="annotation"
                      description="Краткая аннотация фильма"
                      :isDataUpdating="isDataUpdating"
                      :isRequired="isFieldVisible('annotation')"
                      @onChange="saveData"
                  />
	                
                  <div class="field">
                    <label class="label">Месяц выпуска</label>
<!--                    <a-date-picker @change="saveData" v-model:value="project.project_data.mounth_relise" :locale="locale" picker="month"/>-->
                    <BaseMonthPicker
                        v-model="project.project_data.mounth_relise"
                        @on-change="saveData"
                    />
                  </div>

                  <div class="field">
                    <label class="label">Год выпуска</label>
                    <BaseYearPicker
                        v-model="project.project_data.year_relise"
                        @on-change="saveData"
                    />
                  </div>
	                
                  <BaseInput
                      label="Продолжительность фильма (мин.)"
                      :value="project.chronometr"
                      v-if="isFieldVisible('chronometr')"
                      objectKey="chronometr"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('chronometr')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <div class="field" v-if="isFieldVisible('zhanr2')">
                    <label :class="this.isFieldRequired('zhanr2') ? 'req': ''">Жанр</label>
                    <div id="project_zhanr2">
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_21"
                               value="Биография" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_21">Биография</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_1"
                               value="Боевик" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_1">Боевик</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_2"
                               value="Вестерн" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_2">Вестерн</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_3"
                               value="Детектив" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_3">Детектив</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_0"
                               value="Документальное" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_0">Документальное</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_4"
                               value="Драма" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_4">Драма</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_5"
                               value="Детское кино" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_5">Детское кино</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_6"
                               value="Исторический фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_6">Исторический фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_7"
                               value="Комедия" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_7">Комедия</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_8"
                               value="Мелодрама" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_8">Мелодрама</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_9"
                               value="Мистика" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_9">Мистика</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_10"
                               value="Музыкальный фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_10">Музыкальный фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_11"
                               value="Нуар" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_11">Нуар</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_12"
                               value="Политический фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_12">Политический фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_13"
                               value="Приключенческий фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_13">Приключенческий фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_14"
                               value="Сказка" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_14">Сказка</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_15"
                               value="Трагедия" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_15">Трагедия</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_16"
                               value="Трагикомедия" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_16">Трагикомедия</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_17"
                               value="Триллер" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_17">Триллер</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_18"
                               value="Фантастика" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_18">Фантастика</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_19"
                               value="Фильм-катастрофа" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_19">Фильм-катастрофа</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_20"
                               value="Фэнтези" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_20">Фэнтези</label></div>
                    </div>
                  </div>
	                
                  <BaseInput
                      label="Закрытая ссылка на просмотр"
                      :value="project.video_link"
                      v-if="isFieldVisible('video_link')"
                      objectKey="video_link"
                      description="Ссылка для отборочной комиссии. Ссылка должна быть действительна до даты окончания конкурса/акции"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('video_link')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <BaseInput
                      label="Закрытая ссылка на скачивание"
                      :value="project.tagline"
                      objectKey="tagline"
                      description=""
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="true"
                      @changeData="baseInputChangeData"
                  ></BaseInput>
	                
	                

                  <div class="field" v-if="isFieldVisible('tagline')">
                    <label :class="this.isFieldRequired('tagline') ? 'req': ''">Закрытая ссылка на скачивание
                      фильма</label>
                    <p class="field_description">Максимальное разрешение для показа картины. Ссылка должна быть
                      действительна до даты окончания конкурса/акции</p>
                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                              v-model="project.tagline"></textarea>
                  </div>
	                
                  
                </div>
                <div class="column">
                  <div class="field">
                    <label>Какие технологии применялись при производстве фильма</label>
                    <a-select
                        v-model:value="project.project_data.ai_techs"
                        :options="ai_techs_lists"
                        :allowClear="true"
                        placeholder="Выберите значение"
                        @change="saveData"
                        size="middle"
                        style="width: 400px; max-width: 100%"
                    />
                  </div>

                  <BaseInput
                      label="На каком языке снят фильм (видеоролик, клип)"
                      :value="project.film_language"
                      v-if="isFieldVisible('film_language')"
                      objectKey="film_language"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('film_language')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <div class="field" v-if="isFieldVisible('premiera')">
                    <label :class="this.isFieldRequired('premiera') ? 'req': ''">Премьерность фильма</label>
                    <div class="select-field">
                      <select :disabled="isDataUpdating" @change="saveData" v-model="project.project_data.premiera">
                        <option value="демонстрируется впервые">демонстрируется впервые</option>
                        <option value="уже есть в сети Интернет">уже есть в сети Интернет</option>
                      </select>
                    </div>
                  </div>

                  <div class="field">
                    <label :class="this.isFieldRequired('motivation') ? 'req': ''">Мотивация (несколько слов о том, почему для вас было важно рассказать именно эту историю)</label>
                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                              v-model="project.motivation"></textarea>
                  </div>

                  <BaseInput
                      label="Кому принадлежат права на фильм"
                      :value="project.film_rights"
                      v-if="isFieldVisible('film_rights')"
                      objectKey="film_rights"
                      description="Укажите фамилию, имя и отчество человека, которому принадлежат права на видеопроизведение"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('film_rights')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <BaseInput
                      label="Кому принадлежат права на музыку, использованную в фильме (видеоролике, клипе)"
                      :value="project.music_rights"
                      objectKey="music_rights"
                      description="Имеете ли вы право использовать музыку, которая звучит в вашем фильме (видеоролике, клипе)"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="true"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <BaseLocation
                      v-if="project !== null && countriesinput.length > 0"
                      v-model:country="project.country"
                      v-model:city="project.city"
                      v-model:region="project.region"
                      labelCountry="Страна, которую вы представляете"
                      labelCity="Город, который вы представляете"
                      labelRegion="Регион, который вы представляете"
                      :is-city-required="isFieldRequired('city')"
                      :is-country-required="isFieldRequired('country')"
                      :is-region-required="isFieldRequired('region')"
                      @onChange="saveData"
                  ></BaseLocation>
                  <div class="columns">
                    <div class="column">
                      <BaseInput
                          label="Номер телефона"
                          :value="project.film_rights_phone"
                          v-if="isFieldVisible('film_rights_phone')"
                          objectKey="film_rights_phone"
                          description="Укажите номер телефона человека, которому принадлежат права на видеопроизведение"
                          :isDataUpdated="isDataUpdating"
                          :isFormSubmitted="isSubmitted"
                          :is-required="isFieldRequired('film_rights_phone')"
                          @changeData="baseInputChangeData"
                      ></BaseInput>
                    </div>
                    <div class="column">
                      <BaseInput
                          label="Email"
                          :value="project.film_rights_email"
                          v-if="isFieldVisible('film_rights_email')"
                          objectKey="film_rights_email"
                          description="Укажите электронную почту человека, которому принадлежат права на видеопроизведение"
                          :isDataUpdated="isDataUpdating"
                          :isFormSubmitted="isSubmitted"
                          :is-required="isFieldRequired('film_rights_email')"
                          @changeData="baseInputChangeData"
                      ></BaseInput>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="tabNum === 2" class="content-tab">
              <div class="columns">
                <div class="column">

                  <div v-for="(authorScenario, index) in project.project_data.authorScenarios" :key="index">
                    <div class="columns">
                      <div class="column">
                        <BaseInput2
                            label="Автор"
                            v-model="authorScenario.fio"
                            v-if="isFieldVisible('scenarist_text')"
                            objectKey="scenarist_text"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('scenarist_text')"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Номер телефона"
                            v-model="authorScenario.phone"
                            v-if="isFieldVisible('scenarist_phone')"
                            objectKey="scenarist_phone"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            :is-required="isFieldRequired('scenarist_phone')"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Электронная почта"
                            v-model="authorScenario.email"
                            v-if="isFieldVisible('scenarist_email')"
                            objectKey="scenarist_email"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            :is-required="isFieldRequired('scenarist_email')"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field" style="margin-bottom: 0;" v-if="isFieldVisible('scenarist_bio')">
                          <label :class="this.isFieldRequired('scenarist_bio') ? 'req': ''">Краткая биография и
                            фильмография</label>
                          <textarea
                              :disabled="isDataUpdating"
                              @change="saveData"
                              placeholder=""
                              v-model="authorScenario.bio"
                          ></textarea>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field" v-if="selectedCompetition.id == '128'">
                          <AgeField
                              v-model="authorScenario.birthday"
                              @on-change="saveData"
                          />
                        </div>
                      </div>
                    </div>
                    <button @click="removeAuthorScenario(index)" v-if="project.project_data.authorScenarios.length > 1"
                            class="button is-danger">Удалить
                    </button>
                    <hr>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <button @click.prevent="addAuthorScenario" class="button">
                        Добавить автора
                      </button>
                    </div>
                  </div>

                  <div v-for="(producer, index) in project.project_data.producers" :key="index">
                    <div class="columns">
                      <div class="column">
                        <BaseInput2
                            label="Продюсер"
                            v-model="producer.fio"
                            objectKey="producer_text"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Номер телефона"
                            v-model="producer.phone"
                            objectKey="producer_phone"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Электронная почта"
                            v-model="producer.email"
                            objectKey="producer_email"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field" style="margin-bottom: 0;">
                          <label :class="this.isFieldRequired('producer_bio') ? 'req': ''">Краткая биография и
                            фильмография</label>
                          <textarea
                              :disabled="isDataUpdating"
                              @change="saveData"
                              placeholder=""
                              v-model="producer.bio"
                          ></textarea>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field" v-if="selectedCompetition.id == '128'">
                          <AgeField
                              v-model="producer.birthday"
                              @on-change="saveData"
                          />
                        </div>
                      </div>
                    </div>
                    <button @click="removeProducer(index)" v-if="project.project_data.producers.length > 1"
                            class="button is-danger">Удалить
                    </button>
                    <hr>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <button @click.prevent="addProducer" class="button">
                        Добавить продюсера
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </Form>
		  </template>
		  <template v-else>
        <div class="tabs">
          <ul>
            <li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Общая
              информация</a></li>
            <li @click="changeCurrentTab(2)" class="tab tab2" :class="tabNum === 2 ? 'is-active' : ''"><a>Команда</a></li>
          </ul>
        </div>
        <Form ref="clientForm" id="clientForm" v-slot="{errors}">
          <div class="errors-block"
               v-if="Object.keys(errors).length > 0">
            <b>Пожалуйста, заполните поля:</b>
            <ul>
              <li v-for="(error,index) in errors" :key="index">Поле "{{ getFieldNameByIndex(index) }}"
                обязательно для заполнения
              </li>
            </ul>
          </div>

	        <template>
            <Field style="display: none" v-if="isFieldRequired('name')" v-model="project.name" name="name"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('publish_year')" v-model="project.publish_year"
                   name="publish_year" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('chronometr')" v-model="project.chronometr" name="chronometr"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('zhanr')" v-model="project.zhanr" name="zhanr"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('zhanr2')" v-model="project.project_data.zhanr"
                   name="project_data_zhanr" :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.production" name="production"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('film_rights')" v-model="project.film_rights"
                   name="film_rights" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('film_rights_phone')" v-model="project.film_rights_phone"
                   name="film_rights_phone" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('film_rights_email')" v-model="project.film_rights_email"
                   name="film_rights_email" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('video_link')" v-model="project.video_link" name="video_link"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.tagline" name="tagline"
                   :rules="isRequired"></Field>
<!--            <Field style="display: none" v-model="project.social_videolink"-->
<!--                   name="social_videolink" :rules="isRequired"></Field>-->
<!--            <Field style="display: none" v-if="isFieldRequired('video_source')" v-model="project.video_source"-->
<!--                   name="video_source" :rules="isRequired"></Field>-->
<!--            <Field style="display: none" v-model="project.priority_social"-->
<!--                   name="priority_social" :rules="isRequired"></Field>-->
            <Field style="display: none" v-if="isFieldRequired('command_photo')" v-model="commandphoto" name="command_photo"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-model="project.music_rights"
                   name="music_rights" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('country')" v-model="project.country" name="country"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('city')" v-model="project.city" name="city"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('region')" v-model="project.region" name="region"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('film_language')" v-model="project.film_language"
                   name="film_language" :rules="isRequired"></Field>
<!--            <Field style="display: none" v-model="project.motivation" name="motivation"-->
<!--                   :rules="isRequired"></Field>-->
            <Field style="display: none" v-if="isFieldRequired('afisha')" v-model="project.afisha" name="afisha"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('annotation')" v-model="project.annotation" name="annotation"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('inroles')" v-model="inroles" name="inroles"
                   :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('age_limit')" v-model="project.project_data.age_limit"
                   name="age_limit" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('treiler')" v-model="project.project_data.treiler"
                   name="treiler" :rules="isRequired"></Field>
            <Field style="display: none" v-if="isFieldRequired('premiera')" v-model="project.project_data.premiera"
                   name="premiera" :rules="isRequired"></Field>


            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].fio`"
                   v-model="authorScenario.fio"
                   :rules="isFieldRequired('scenarist_text') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].phone`"
                   v-model="authorScenario.phone"
                   :rules="isFieldRequired('scenarist_phone') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].email`"
                   v-model="authorScenario.email"
                   :rules="isFieldRequired('scenarist_email') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-fio`"
                   :name="`authorScenarios[${index}].bio`"
                   v-model="authorScenario.bio"
                   :rules="isFieldRequired('scenarist_bio') ? isRequired : undefined"
                   style="display: none"
            ></Field>
		        

            <Field v-for="(item, index) in project.project_data.regisers" :key="`regisers-${index}-fio`"
                   :name="`regisers[${index}].fio`"
                   v-model="item.fio"
                   :rules="isFieldRequired('scenarist_text') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.regisers" :key="`regisers-${index}-phone`"
                   :name="`regisers[${index}].phone`"
                   v-model="item.phone"
                   :rules="isFieldRequired('scenarist_phone') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.regisers" :key="`regisers-${index}-email`"
                   :name="`regisers[${index}].email`"
                   v-model="item.email"
                   :rules="isFieldRequired('scenarist_email') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.regisers" :key="`regisers-${index}-bio`"
                   :name="`regisers[${index}].bio`"
                   v-model="item.bio"
                   :rules="isFieldRequired('scenarist_bio') ? isRequired : undefined"
                   style="display: none"
            ></Field>


            <Field v-for="(item, index) in project.project_data.producers" :key="`producers-${index}-fio`"
                   :name="`producers[${index}].fio`"
                   v-model="item.fio"
                   :rules="isFieldRequired('producer_text') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.producers" :key="`producers-${index}-phone`"
                   :name="`producers[${index}].phone`"
                   v-model="item.phone"
                   :rules="isFieldRequired('producer_phone') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.producers" :key="`producers-${index}-email`"
                   :name="`producers[${index}].email`"
                   v-model="item.email"
                   :rules="isFieldRequired('producer_email') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.producers" :key="`producers-${index}-bio`"
                   :name="`producers[${index}].bio`"
                   v-model="item.bio"
                   :rules="isFieldRequired('producer_bio') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.operators" :key="`operators-${index}-fio`"
                   :name="`operators[${index}].fio`"
                   v-model="item.fio"
                   :rules="isFieldRequired('operator_text') ? isRequired : undefined"
                   style="display: none"
            ></Field>

            

            <Field v-for="(authorScenario, index) in project.project_data.authorScenarios"
                   :key="`authorScenarios-${index}-birthday`"
                   :name="`authorScenarios[${index}].birthday`"
                   v-model="authorScenario.birthday"
                   :rules="isRequired"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.regisers" :key="`regisers-${index}-birthday`"
                   :name="`regisers[${index}].birthday`"
                   v-model="item.birthday"
                   :rules="isRequired"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.producers" :key="`producers-${index}-birthday`"
                   :name="`producers[${index}].birthday`"
                   v-model="item.birthday"
                   :rules="isRequired"
                   style="display: none"
            ></Field>

            <Field v-for="(item, index) in project.project_data.operators" :key="`operators-${index}-birthday`"
                   :name="`operators[${index}].birthday`"
                   v-model="item.birthday"
                   :rules="isRequired"
                   style="display: none"
            ></Field>

<!--            <Field v-for="(item, index) in project.project_data.compositors" :key="`compositors-${index}-birthday`"-->
<!--                   :name="`compositors[${index}].birthday`"-->
<!--                   v-model="item.birthday"-->
<!--                   :rules="isRequired"-->
<!--                   style="display: none"-->
<!--            ></Field>-->

<!--            <Field v-for="(item, index) in project.project_data.hydozniks" :key="`hydozniks-${index}-birthday`"-->
<!--                   :name="`hydozniks[${index}].birthday`"-->
<!--                   v-model="item.birthday"-->
<!--                   style="display: none"-->
<!--                   :rules="isRequired"-->
<!--            ></Field>-->
	        </template>
          
	        
          <div v-if="!selectedCompetition?.name">
            <p class="help_text" @click="$parent.showModalQuestion">
              <FontAwesomeIcon icon="question"></FontAwesomeIcon>
              Почему я не вижу обязательные поля для этого проекта?
            </p>
          </div>


          <div id="tabContent">
            <div v-if="tabNum === 1" class="content-tab">
              <div class="columns">
                <div class="column">
                  <BaseInput
                      label="Название фильма"
                      :value="project.name"
                      v-if="isFieldVisible('name')"
                      objectKey="name"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('name')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <BaseInput
                      label="Год выпуска"
                      :value="project.publish_year"
                      v-if="isFieldVisible('publish_year')"
                      objectKey="publish_year"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('publish_year')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <BaseInput
                      label="Продолжительность фильма (мин.)"
                      :value="project.chronometr"
                      v-if="isFieldVisible('chronometr')"
                      objectKey="chronometr"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('chronometr')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <div class="field" v-if="isFieldVisible('zhanr')">
                    <label :class="this.isFieldRequired('zhanr') ? 'req': ''">Формат</label>
                    <div v-if="selectedCompetition?.formats">
                      <template v-for="(format,index) in selectedCompetition?.formats" :key="index">
                        <div class="checkbox__wrapper">
                          <input :disabled="isDataUpdating" @change="saveData" type="checkbox" :id="'project_zhanr_'+index"
                                 :value="format" v-model="project.zhanr">
                          <label :for="'project_zhanr_'+index">{{ format }}</label>
                        </div>
                      </template>
                    </div>
                    <div v-else>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_0"
                               value="Документальное кино" v-model="project.zhanr">
                        <label for="project_zhanr_0">Документальное кино</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_1"
                               value="Игровое короткометражное кино" v-model="project.zhanr">
                        <label for="project_zhanr_1">Игровое короткометражное кино</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_2"
                               value="Игровое полнометражное кино" v-model="project.zhanr">
                        <label for="project_zhanr_2">Игровое полнометражное кино</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_3"
                               value="Сериалы" v-model="project.zhanr">
                        <label for="project_zhanr_3">Сериалы</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox" id="project_zhanr_4"
                               value="Work in progress" v-model="project.zhanr">
                        <label for="project_zhanr_4">Work in progress</label>
                      </div>
                    </div>
                  </div>

                  <div class="field" v-if="isFieldVisible('zhanr2')">
                    <label :class="this.isFieldRequired('zhanr2') ? 'req': ''">Жанр</label>
                    <div id="project_zhanr2">
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_21"
                               value="Биография" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_21">Биография</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_1"
                               value="Боевик" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_1">Боевик</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_2"
                               value="Вестерн" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_2">Вестерн</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_3"
                               value="Детектив" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_3">Детектив</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_0"
                               value="Документальное" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_0">Документальное</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_4"
                               value="Драма" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_4">Драма</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_5"
                               value="Детское кино" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_5">Детское кино</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_6"
                               value="Исторический фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_6">Исторический фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_7"
                               value="Комедия" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_7">Комедия</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_8"
                               value="Мелодрама" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_8">Мелодрама</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_9"
                               value="Мистика" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_9">Мистика</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_10"
                               value="Музыкальный фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_10">Музыкальный фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_11"
                               value="Нуар" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_11">Нуар</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_12"
                               value="Политический фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_12">Политический фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_13"
                               value="Приключенческий фильм" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_13">Приключенческий фильм</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_14"
                               value="Сказка" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_14">Сказка</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_15"
                               value="Трагедия" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_15">Трагедия</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_16"
                               value="Трагикомедия" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_16">Трагикомедия</label>
                      </div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_17"
                               value="Триллер" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_17">Триллер</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_18"
                               value="Фантастика" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_18">Фантастика</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_19"
                               value="Фильм-катастрофа" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_19">Фильм-катастрофа</label></div>
                      <div class="checkbox__wrapper">
                        <input :disabled="isDataUpdating" @change="saveData" type="checkbox"
                               id="project_zhanr2_20"
                               value="Фэнтези" v-model="project.project_data.zhanr">
                        <label for="project_zhanr2_20">Фэнтези</label></div>
                    </div>
                  </div>

                  <div class="field">
                    <label class="req">Производство (кинокомпания, студия
                      и.т.д.)</label>
                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                              v-model="project.production"></textarea>
                  </div>

                </div>
                <div class="column">

                  <div>
                    <ImageRender
                        id="image"
                        :src="getProjectAvatar(project.afisha)"
                    ></ImageRender>
                  </div>

                  <vue-cropper
                      ref="cropper"
                      :src="imgSrc"
                      alt="Source Image"
                      :aspect-ratio="366 / 546"
                      preview=".preview"
                      v-if="imgSrc != ''"
                  >
                  </vue-cropper>
                  <button class="button2" @click.prevent="cropImage" v-if="imgSrc != ''" style="margin-right: 40px;">
                    Сохранить изображение
                  </button>

                  <div class="field" v-if="isFieldVisible('afisha')">
                    <label :class="this.isFieldRequired('afisha') ? 'req': ''" for="project_afisha">Афиша проекта /
                      Картинка характеризующая проект (Формат jpeg/png. Макс. 1,5 мегабайт)</label>
                    <i class="fas fa-download"></i>
                    <input :disabled="isDataUpdating" type="file" accept="image/*" id="project_afisha"
                           name="project[afisha]" @change="setImage">
                    <div id="fileList"></div>
                    <p style="font-size: 13px; margin-top: 10px;">Ссылка на скачивание постера фильма
                      * (ссылка должна быть действительна до даты окончания конкурса/акции)</p>
                  </div>

                  <TinymceEditor
                      label="Краткая аннотация"
                      v-model="project.annotation"
                      v-if="isFieldVisible('annotation')"
                      objectKey="annotation"
                      description="Сделайте краткое описание вашего фильма"
                      :isDataUpdating="isDataUpdating"
                      :isRequired="isFieldVisible('annotation')"
                      @onChange="saveData"
                  />
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BaseInput
                      label="Кому принадлежат права на фильм"
                      :value="project.film_rights"
                      v-if="isFieldVisible('film_rights')"
                      objectKey="film_rights"
                      description="Укажите фамилию, имя и отчество человека, которому принадлежат права на видеопроизведение"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('film_rights')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>
                </div>
                <div class="column">
                  <BaseInput
                      label="Номер телефона"
                      :value="project.film_rights_phone"
                      v-if="isFieldVisible('film_rights_phone')"
                      objectKey="film_rights_phone"
                      description="Укажите номер телефона человека, которому принадлежат права на видеопроизведение"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('film_rights_phone')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>
                </div>
                <div class="column">
                  <BaseInput
                      label="Email"
                      :value="project.film_rights_email"
                      v-if="isFieldVisible('film_rights_email')"
                      objectKey="film_rights_email"
                      description="Укажите электронную почту человека, которому принадлежат права на видеопроизведение"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('film_rights_email')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <BaseInput
                      label="Закрытая ссылка для просмотра фильма"
                      :value="project.video_link"
                      v-if="isFieldVisible('video_link')"
                      objectKey="video_link"
                      description="Ссылка для отборочной комиссии. Ссылка должна быть действительна до даты окончания конкурса/акции"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('video_link')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <div class="field">
                    <label class="req">Закрытая ссылка на скачивание фильма</label>
                    <p class="field_description">Максимальное разрешение для показа картины. Ссылка должна быть
                      действительна до даты окончания конкурса/акции</p>
                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""
                              v-model="project.tagline"></textarea>
                  </div>

<!--                  <div class="field">-->
<!--                    <label class="req">Ссылка на фильм (видеоролик, клип), размещенный в социальных сетях</label>-->
<!--                    <p class="field_description">В этом поле, если есть, укажите ссылки на посты в любых соцсетях, в-->
<!--                      которых содержатся ссылки на трейлер или тизер проекта.</p>-->
<!--                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""-->
<!--                              v-model="project.social_videolink"></textarea>-->
<!--                  </div>-->

<!--                  <BaseInput-->
<!--                      label="Ссылка на исходные материалы для фильма"-->
<!--                      :value="project.video_source"-->
<!--                      v-if="isFieldVisible('video_source')"-->
<!--                      objectKey="video_source"-->
<!--                      description="Здесь разместите ссылки на любые отснятые, но не обработанные или не смонтированные материалы — они пригодятся журналистам для того, чтобы создать сюжет на телеканале и коротко рассказать о вашем проекте среди общей подборки. Пожалуйста, сделайте для исходников отдельную папку и используйте название финального видеоролика в названиях файлов."-->
<!--                      :isDataUpdated="isDataUpdating"-->
<!--                      :isFormSubmitted="isSubmitted"-->
<!--                      :is-required="isFieldRequired('video_source')"-->
<!--                      @changeData="baseInputChangeData"-->
<!--                  ></BaseInput>-->

<!--                  <div class="field">-->
<!--                    <label class="req">Ссылки на социальные сети-->
<!--                      проекта</label>-->
<!--                    <p class="field_description">В этом поле укажите ссылку на одну приоритетную социальную сеть-->
<!--                      проекта.</p>-->
<!--                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""-->
<!--                              v-model="project.priority_social"></textarea>-->
<!--                  </div>-->

                  <BaseInput2
                      label="Ссылка на кадры"
                      v-if="isFieldVisible('command_photo')"
                      v-model="commandphoto"
                      objectKey="command_photo"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      @onChange="saveData"
                      :is-required="isFieldRequired('command_photo')"
                  ></BaseInput2>

                  <BaseInput
                      label="Кому принадлежат права на музыку, использованную в фильме (видеоролике, клипе)"
                      :value="project.music_rights"
                      objectKey="music_rights"
                      description="Имеете ли вы право использовать музыку, которая звучит в вашем фильме (видеоролике, клипе)"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="true"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

                  <!--              <BaseLocation-->
                  <!--                  v-if="project !== null && countriesinput.length > 0"-->
                  <!--                  :countriesinput="countriesinput"-->
                  <!--                  countryKey="country"-->
                  <!--                  cityKey="city"-->
                  <!--                  regionKey="region"-->
                  <!--                  labelCountry="Страна, которую вы представляете"-->
                  <!--                  labelCity="Город, который вы представляете"-->
                  <!--                  labelRegion="Регион, который вы представляете"-->
                  <!--                  :isDataUpdating="isDataUpdating"-->
                  <!--              ></BaseLocation>-->

                  <BaseLocation
                      v-if="project !== null && countriesinput.length > 0"
                      v-model:country="project.country"
                      v-model:city="project.city"
                      v-model:region="project.region"
                      labelCountry="Страна, которую вы представляете"
                      labelCity="Город, который вы представляете"
                      labelRegion="Регион, который вы представляете"
                      :is-city-required="isFieldRequired('city')"
                      :is-country-required="isFieldRequired('country')"
                      :is-region-required="isFieldRequired('region')"
                      @onChange="saveData"
                  ></BaseLocation>

                  <BaseInput
                      label="На каком языке снят фильм (видеоролик, клип)"
                      :value="project.film_language"
                      v-if="isFieldVisible('film_language')"
                      objectKey="film_language"
                      :isDataUpdated="isDataUpdating"
                      :isFormSubmitted="isSubmitted"
                      :is-required="isFieldRequired('film_language')"
                      @changeData="baseInputChangeData"
                  ></BaseInput>

<!--                  <div class="field">-->
<!--                    <label class="req">Мотивация (несколько слов о том, почему-->
<!--                      для вас было важно рассказать именно эту историю)</label>-->
<!--                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder=""-->
<!--                              v-model="project.motivation"></textarea>-->
<!--                  </div>-->
                </div>
                <div class="column">
                  <div class="field" v-if="isFieldVisible('inroles')">
                    <label :class="this.isFieldRequired('inroles') ? 'req': ''">В ролях</label>
                    <textarea :disabled="isDataUpdating" @change="saveData" placeholder="" v-model="inroles"></textarea>
                  </div>

                  <div class="field" v-if="isFieldVisible('age_limit')">
                    <BaseInput3
                        label="Возрастное ограничение фильма (0+, 6+, 12+, 16+ или 18+)"
                        v-model="project.project_data.age_limit"
                        objectKey="age_limit"
                        :isDataUpdated="isDataUpdating"
                        :isFormSubmitted="isSubmitted"
                        @onChange="saveData"
                        :isRequired="isFieldRequired('age_limit')"
                    ></BaseInput3>
                  </div>

                  <div class="field" v-if="isFieldVisible('treiler')">
                    <BaseInput3
                        label="Ссылка на трейлер фильма"
                        v-model="project.project_data.treiler"
                        objectKey="treiler"
                        :isDataUpdated="isDataUpdating"
                        :isFormSubmitted="isSubmitted"
                        @onChange="saveData"
                        :is-required="isFieldRequired('treiler')"
                    ></BaseInput3>
                  </div>

                  <div class="field" v-if="isFieldVisible('premiera')">
                    <label :class="this.isFieldRequired('premiera') ? 'req': ''">Премьерность фильма</label>
                    <div class="select-field">
                      <select :disabled="isDataUpdating" @change="saveData" v-model="project.project_data.premiera">
                        <option value="мировая">мировая</option>
                        <option value="международная">международная</option>
                        <option value="российская">российская</option>
                        <option value="московская премьера">московская премьера</option>
                        <option value="нет">нет</option>
                      </select>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div v-if="tabNum === 2" class="content-tab">
              <div class="columns">
                <div class="column">

                  <div v-for="(authorScenario, index) in project.project_data.authorScenarios" :key="index">
                    <div class="columns">
                      <div class="column">
                        <BaseInput2
                            label="Автор сценария"
                            v-model="authorScenario.fio"
                            v-if="isFieldVisible('scenarist_text')"
                            objectKey="scenarist_text"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('scenarist_text')"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Номер телефона"
                            v-model="authorScenario.phone"
                            v-if="isFieldVisible('scenarist_phone')"
                            objectKey="scenarist_phone"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            :is-required="isFieldRequired('scenarist_phone')"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Электронная почта"
                            v-model="authorScenario.email"
                            v-if="isFieldVisible('scenarist_email')"
                            objectKey="scenarist_email"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            :is-required="isFieldRequired('scenarist_email')"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field" style="margin-bottom: 0;" v-if="isFieldVisible('scenarist_bio')">
                          <label :class="this.isFieldRequired('scenarist_bio') ? 'req': ''">Краткая биография и
                            фильмография</label>
                          <textarea
                              :disabled="isDataUpdating"
                              @change="saveData"
                              placeholder=""
                              v-model="authorScenario.bio"
                          ></textarea>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field" v-if="selectedCompetition.id == '128'">
                          <AgeField
                              v-model="authorScenario.birthday"
                              @on-change="saveData"
                          />
                        </div>
                      </div>
                    </div>
                    <button @click="removeAuthorScenario(index)" v-if="project.project_data.authorScenarios.length > 1"
                            class="button is-danger">Удалить
                    </button>
                    <hr>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <button @click.prevent="addAuthorScenario" class="button">
                        Добавить автора сценария
                      </button>
                    </div>
                  </div>

                  <div v-for="(regiser, index) in project.project_data.regisers" :key="index">
                    <div class="columns">
                      <div class="column">
                        <BaseInput2
                            label="Режиссер"
                            v-model="regiser.fio"
                            v-if="isFieldVisible('regiser_text')"
                            objectKey="regiser_text"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('regiser_text')"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Номер телефона"
                            v-model="regiser.phone"
                            v-if="isFieldVisible('regiser_phone')"
                            objectKey="regiser_phone"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('regiser_phone')"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Электронная почта"
                            v-model="regiser.email"
                            v-if="isFieldVisible('regiser_email')"
                            objectKey="regiser_email"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            :is-required="isFieldRequired('regiser_email')"
                            @onChange="saveData"
                        ></BaseInput2>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field" style="margin-bottom: 0;" v-if="isFieldVisible('regiser_bio')">
                          <label :class="this.isFieldRequired('regiser_bio') ? 'req': ''">Краткая биография и
                            фильмография</label>
                          <textarea
                              :disabled="isDataUpdating"
                              @change="saveData"
                              placeholder=""
                              v-model="regiser.bio"
                          ></textarea>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field" v-if="selectedCompetition.id == '128'">
                          <AgeField
                              v-model="regiser.birthday"
                              @on-change="saveData"
                          />
                        </div>
                      </div>
                    </div>
                    <button @click="removeRegiser(index)" v-if="project.project_data.regisers.length > 1"
                            class="button is-danger">Удалить
                    </button>
                    <hr>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <button @click.prevent="addRegiser" class="button">
                        Добавить режиссера
                      </button>
                    </div>
                  </div>

                  <div v-for="(producer, index) in project.project_data.producers" :key="index">
                    <div class="columns">
                      <div class="column">
                        <BaseInput2
                            label="Продюсер"
                            v-model="producer.fio"
                            v-if="isFieldVisible('producer_text')"
                            objectKey="producer_text"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('producer_text')"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Номер телефона"
                            v-model="producer.phone"
                            v-if="isFieldVisible('producer_phone')"
                            objectKey="producer_phone"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('producer_phone')"
                        ></BaseInput2>
                      </div>
                      <div class="column">
                        <BaseInput2
                            label="Электронная почта"
                            v-model="producer.email"
                            v-if="isFieldVisible('producer_email')"
                            objectKey="producer_email"
                            :isDataUpdated="isDataUpdating"
                            :isFormSubmitted="isSubmitted"
                            @onChange="saveData"
                            :is-required="isFieldRequired('producer_email')"
                        ></BaseInput2>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <div class="field" style="margin-bottom: 0;" v-if="isFieldVisible('producer_bio')">
                          <label :class="this.isFieldRequired('producer_bio') ? 'req': ''">Краткая биография и
                            фильмография</label>
                          <textarea
                              :disabled="isDataUpdating"
                              @change="saveData"
                              placeholder=""
                              v-model="producer.bio"
                          ></textarea>
                        </div>
                      </div>
                      <div class="column">
                        <div class="field" v-if="selectedCompetition.id == '128'">
                          <AgeField
                              v-model="producer.birthday"
                              @on-change="saveData"
                          />
                        </div>
                      </div>
                    </div>
                    <button @click="removeProducer(index)" v-if="project.project_data.producers.length > 1"
                            class="button is-danger">Удалить
                    </button>
                    <hr>
                  </div>
                  <div class="columns">
                    <div class="column">
                      <button @click.prevent="addProducer" class="button">
                        Добавить продюсера
                      </button>
                    </div>
                  </div>

                  <div>
                    <div v-for="(operator, index) in project.project_data.operators" :key="index">
                      <div class="columns">
                        <div class="column no_margin">
                          <BaseInput2
                              label="Оператор"
                              v-model="operator.fio"
                              v-if="isFieldVisible('operator_text')"
                              objectKey="operator_text"
                              :isDataUpdated="isDataUpdating"
                              :isFormSubmitted="isSubmitted"
                              @onChange="saveData"
                              :is-required="isFieldRequired('operator_text')"
                          ></BaseInput2>
                        </div>
                        <div class="column">
                          <div class="field" v-if="selectedCompetition.id == '128'">
                            <AgeField
                                v-model="operator.birthday"
                                @on-change="saveData"
                            />
                          </div>
                        </div>
                      </div>
                      <button @click="removeOperator(index)" v-if="project.project_data.operators.length > 1"
                              class="button is-danger">Удалить
                      </button>
                      <hr>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <button @click.prevent="addOperator" class="button">
                          Добавить оператора
                        </button>
                      </div>
                    </div>

                    <div v-for="(compositor, index) in project.project_data.compositors" :key="index">
                      <div class="columns">
                        <div class="column no_margin">
                          <BaseInput2
                              label="Композитор"
                              v-model="compositor.fio"
                              v-if="isFieldVisible('compositor_text')"
                              objectKey="compositor_text"
                              :isDataUpdated="isDataUpdating"
                              :isFormSubmitted="isSubmitted"
                              @onChange="saveData"
                          ></BaseInput2>
                        </div>
                        <div class="column">
                        </div>
                      </div>
                      <button @click="removeCompositor(index)" v-if="project.project_data.compositors.length > 1"
                              class="button is-danger">Удалить
                      </button>
                      <hr>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <button @click.prevent="addCompositor" class="button">
                          Добавить композитора
                        </button>
                      </div>
                      <div class="column"></div>
                    </div>

                    <div v-for="(hydoznik, index) in project.project_data.hydozniks" :key="index">
                      <div class="columns">
                        <div class="column no_margin">
                          <BaseInput2
                              label="Художник-постановщик"
                              v-model="hydoznik.fio"
                              v-if="isFieldVisible('chudoznik_text')"
                              objectKey="chudoznik_text"
                              :isDataUpdated="isDataUpdating"
                              :isFormSubmitted="isSubmitted"
                              @onChange="saveData"
                          ></BaseInput2>
                        </div>
                        <div class="column">
                        </div>
                      </div>
                      <button @click="removeHydoznik(index)" v-if="project.project_data.hydozniks.length > 1"
                              class="button is-danger">Удалить
                      </button>
                      <hr>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <button @click.prevent="addHydoznik" class="button">
                          Добавить художника-постановщика
                        </button>
                      </div>
                      <div class="column"></div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </Form>
		  </template>
	  </template>
  </div>
  <div v-else style="text-align: center">
    <a-spin style="margin-top: 20px;"/>
  </div>
</template>

<style scoped>
.field_description {
    font-size: 13px;
}


.modal {
    display: block;
    width: 80%;
    max-width: 950px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 20px;
    text-align: center;
    margin: 30px auto 30px;
    position: relative;
}

.category_select_active {
    font-weight: bold;
}

.close_button {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
}

.vue-universal-modal {
    z-index: 111;
}

.errors-block {
    color: red;
    border: 1px solid #999;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
}

.lds-default {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transform: scale(0.5);
    text-align: center;
}

.lds-default div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #000;
    border-radius: 50%;
    animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
    animation-delay: 0s;
    top: 37px;
    left: 66px;
}

.lds-default div:nth-child(2) {
    animation-delay: -0.1s;
    top: 22px;
    left: 62px;
}

.lds-default div:nth-child(3) {
    animation-delay: -0.2s;
    top: 11px;
    left: 52px;
}

.lds-default div:nth-child(4) {
    animation-delay: -0.3s;
    top: 7px;
    left: 37px;
}

.lds-default div:nth-child(5) {
    animation-delay: -0.4s;
    top: 11px;
    left: 22px;
}

.lds-default div:nth-child(6) {
    animation-delay: -0.5s;
    top: 22px;
    left: 11px;
}

.lds-default div:nth-child(7) {
    animation-delay: -0.6s;
    top: 37px;
    left: 7px;
}

.lds-default div:nth-child(8) {
    animation-delay: -0.7s;
    top: 52px;
    left: 11px;
}

.lds-default div:nth-child(9) {
    animation-delay: -0.8s;
    top: 62px;
    left: 22px;
}

.lds-default div:nth-child(10) {
    animation-delay: -0.9s;
    top: 66px;
    left: 37px;
}

.lds-default div:nth-child(11) {
    animation-delay: -1s;
    top: 62px;
    left: 52px;
}

.lds-default div:nth-child(12) {
    animation-delay: -1.1s;
    top: 52px;
    left: 62px;
}

.content_block .tabs ul {
    align-items: inherit;
}

.content_block .tabs ul li {
    display: flex;
}


.help_text {
    margin-bottom: 30px;
    margin-top: 30px;
    font-style: italic;
    color: #8F9194;
    cursor: pointer;
}

.help_text svg {
    margin-right: 10px;
}

.modal_question {
    text-align: left;
    font-size: 16px;
}

.no_margin:deep .field {
    margin-bottom: 0;
}

@keyframes lds-default {
    0%, 20%, 80%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
}
</style>
